var Panel       = require("./Panel"),
    $           = require("jquery"),
    Legend      = require("./Legend/Legend");

var LegendGroup  = Panel.extend({

    options: {
        watchLegendVisibility: true
    },

    initialize: function(options){
        'use strict'
        var that = this;

        that.collapsed = false;

        that._legends = [];

        LegendGroup.__super__.initialize.call(that, options);

        that._container.addClass('omjs-panel legend-group');

        that.getContentContainer()
            .append($('<div class="close-button"></div>'))
            .on('click', function(){
                if (that.collapsed) {
                    that.expand();
                }
            })
            .on('click', '.close-button', function(){
                that.collapse();
                return false;
            });

        that.getContentContainer().append('<div class="legends-container"></div>');

        that._contentContainer = that.getContentContainer().find(".legends-container");

        that.hide();
    },

    onAdd: function(view){
        'use strict'
        var that = this;
        that.view = view;
    },

    addLegend: function(legend, id){
        'use strict'
        var that = this;

        if (!legend || !(legend instanceof Legend) || ~that._legends.indexOf(legend)) {
            return that;
        }

        that._legends.push(legend);
        that.getContentContainer().append(legend._container);

        that._legendVisibilityHandler();
        legend.on('show', that._legendVisibilityHandler, that);
        legend.on('hide', that._legendVisibilityHandler, that);

        if (id) {
            legend._grpId = id;
        }

        return that;
    },

    removeLegend: function(legend){
        'use strict'
        var that = this;

        if (!legend) {
            return that;
        }

        if (!(legend instanceof Legend)) {
            legend = that.getById(legend);
        }

        if (legend) {
            legend.getContainer().detach();
            that._legends.splice(that._legends.indexOf(legend), 1);
            that._legendVisibilityHandler();
            legend.off('show', that._legendVisibilityHandler, that);
            legend.off('hide', that._legendVisibilityHandler, that);
        }

        return that;
    },

    _legendVisibilityHandler: function(){
        'use strict'
        var that = this;
        if(that.options.watchLegendVisibility){
            that.getVisibleChilds().length > 0 ? that.show() : that.hide();    
        }
    },

    getById: function(id){
        'use strict'
        var that = this,
            legend;

        legend = that._legends.filter(function(l){
            return l._grpId == id;
        });

        return legend.length > 0 ? legend[0] : false;
    },

    collapse: function(){
        'use strict'
        var that = this;
        that.getContainer().addClass('collapsed');
        that.collapsed = true;
    },

    expand: function(){
        'use strict'
        var that = this;
        that.getContainer().removeClass('collapsed');
        that.collapsed = false;
    },

    getVisibleChilds: function(){
        'use strict'
        var that = this,
            legends;

        legends = that._legends.filter(function(l){
            return !l.isHidden();
        });

        return legends;
    }
});

module.exports = LegendGroup;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/LegendGroup.js
// module id = 223
// module chunks = 0